import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[sharedOnlyNumber]',
})
export class OnlyNumberDirective {
  constructor(private readonly host: ElementRef<HTMLInputElement>) {}

  private readonly specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'Left', 'ArrowLeft', 'Right', 'ArrowRight', 'Delete'];

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const input = this.host.nativeElement;

    if (
      this.specialKeys.includes(event.key) ||
      // allows dash
      // selectionStart and selectionEnd does not work with input type "number"
      (event.key === '-' && input.selectionStart === 0 && input.selectionEnd === 0) ||
      // allows one dot
      (event.key === '.' && input.value?.length > 0 && !input.value.includes('.')) ||
      // allows copy-pasting and selecting
      (['a', 'c', 'v', 'x'].includes(event.key) && (event.ctrlKey || event.metaKey))
    ) {
      return;
    } else if (event.key === ' ' || isNaN(Number(event.key))) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const input = this.host.nativeElement;
    const pastedText = event.clipboardData?.getData('text') ?? '';

    // selectionStart and selectionEnd does not work with input type "number"
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;

    const finalValue = input.value.substring(0, start) + pastedText + input.value.substring(end);

    if (!this.isValidNumber(finalValue)) {
      event.preventDefault();
    }
  }

  private isValidNumber(value: string): boolean {
    // Trim and validate the final value
    const trimmed = value.trim();

    // Must match a valid number format: optional leading minus, digits, optional single dot
    const numberPattern = /^-?\d*\.?\d*$/;

    // Reject if multiple dots or misplaced minus
    if (!numberPattern.test(trimmed)) {
      return false;
    }

    // Reject if multiple minus signs or minus not at the start
    if ((trimmed.match(/-/g)?.length ?? 0) > 1 || (trimmed.includes('-') && !trimmed.startsWith('-'))) {
      return false;
    }

    return true;
  }
}
